// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LookupModel {
    static getAttributeTypeMap() {
        return LookupModel.attributeTypeMap;
    }
}
LookupModel.discriminator = undefined;
LookupModel.additionalProperties = false;
LookupModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=lookupModel.js.map